import classNames from 'classnames';

interface SummaryChipsProps {
  summary: string[];
}

const SummaryChips = ({ summary }: SummaryChipsProps) => (
  <ul className="ac-result__summary ac-result__summary-chips ch-ph--2 ch-width--12">
    {summary.map((item, index) => (
      <li
        className={classNames(
          'ch-fs--1 ch-ph--1 ch-fw--500 ch-chip ch-chip--grey-2 ch-lh--body',
          { 'ac-result__summary-item--electric': item === 'Electric' },
        )}
        key={index}
      >
        <span className="ac-result__summary-chip-label ch-text--ellipsis">
          {item}
        </span>
      </li>
    ))}
  </ul>
);

export default SummaryChips;
